/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import { ProgressSpinner } from "primereact/progressspinner";

import * as S from "./styles";

import { svgs } from "../../../assets";

const ConfirmRegister: React.FC = () => (
  <S.Container>
    <S.Header>
      <img src={svgs.LucralizeLogo} alt="logo" />
    </S.Header>
    <S.SpinnerWrapper>
      <ProgressSpinner />
    </S.SpinnerWrapper>
    <S.TermsLink to="/termos-de-uso">Termos de privacidade</S.TermsLink>
  </S.Container>
);
export default ConfirmRegister;
